import banner from './banner'

export default banner
